import 'antd-mobile/es/global';
import '@/app/styles/index.css';
import waSaiBridge from '@/app/api/waSaiBridge';
import App from '@/app/App';
import AppProvider from '@/app/providers/AppProvider';
import { myCouponNamespaceResources } from '@/features/myCoupon/locales';
import { shopCouponNamespaceResources } from '@/features/shopCoupon/locales';
import { shopRegistrationComponentsNamespaceResources } from '@/features/shopRegistration/components/locales';
import { walletNamespaceResources } from '@/features/wallet/locales';
import { wpaNamespaceResources } from '@/features/wpa/locales';
import { registerResources, setupI18n } from '@/shared/i18n';
import { commonNamespaceResources } from '@/shared/locales';
import { experimental_extendTheme as materialExtendTheme } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const materialTheme = materialExtendTheme();
const primaryColor =
  getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() ||
  '#FFAB00';

document.body.style.margin = '0';

// 在入口初始化 i18n，并注册各 feature 资源
setupI18n(waSaiBridge.getLanguage());
registerResources({ ns: 'wpa', resources: wpaNamespaceResources });
registerResources({ ns: 'wallet', resources: walletNamespaceResources });
registerResources({ ns: 'common', resources: commonNamespaceResources });
registerResources({ ns: 'myCoupon', resources: myCouponNamespaceResources });
registerResources({ ns: 'shopCoupon', resources: shopCouponNamespaceResources });
registerResources({ ns: 'shopRegistrationComponents', resources: shopRegistrationComponentsNamespaceResources });


const root = createRoot(container!);
root.render(
  <AppProvider container={container} materialTheme={materialTheme} primaryColor={primaryColor}>
    <App />
  </AppProvider>,
);
